module.exports = __webpack_public_path__ + "img/user2.3235c5ba.svg";